// Access the strings used on the insertEmailCode page.
export const t_insertUsernameCode = {
  title: "signup.insertUsernameCode.title",
  subtitle: "signup.insertUsernameCode.subtitle",
  codePlaceholder: "signup.insertUsernameCode.codePlaceholder",
};
